import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Cpu, ShieldCheck, Sparkles } from 'lucide-react';

export default function AuthExperienceShell({
  badge,
  title,
  description,
  backTo,
  backLabel,
  highlights = [],
  children,
  sideNode,
  testId = 'auth-experience-shell',
}) {
  return (
    <div className="hsx-landing-root min-h-screen overflow-x-hidden px-4 py-6 md:px-6 md:py-10" data-testid={testId}>
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-6 lg:grid-cols-[1.1fr_0.9fr]">
        <section className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#0f1728]/85 p-6 md:p-8">
          <div className="pointer-events-none absolute -left-10 -top-10 h-44 w-44 rounded-full bg-orange-500/20 blur-3xl" />
          <div className="pointer-events-none absolute -right-12 bottom-0 h-48 w-48 rounded-full bg-cyan-500/15 blur-3xl" />

          {backTo && (
            <Link
              to={backTo}
              className="relative z-10 mb-5 inline-flex items-center text-xs text-slate-300 hover:text-white"
              data-testid="auth-shell-back-link"
            >
              <ArrowLeft className="mr-1 h-3.5 w-3.5" />
              {backLabel || 'Back'}
            </Link>
          )}

          <div className="relative z-10">
            <span className="inline-flex items-center rounded-full border border-orange-400/30 bg-orange-500/10 px-3 py-1 text-xs font-medium text-orange-300" data-testid="auth-shell-badge">
              <Sparkles className="mr-1 h-3.5 w-3.5" />
              {badge}
            </span>
            <h1 className="mt-4 text-4xl font-bold text-white md:text-5xl" data-testid="auth-shell-title">{title}</h1>
            <p className="mt-3 max-w-xl text-sm text-slate-300 md:text-base" data-testid="auth-shell-description">{description}</p>

            <div className="mt-6 grid gap-3 sm:grid-cols-3" data-testid="auth-shell-highlights-grid">
              {(highlights.length > 0
                ? highlights
                : [
                    { icon: ShieldCheck, text: 'Role-aware account protection' },
                    { icon: Cpu, text: 'Operational workflows by user type' },
                    { icon: Sparkles, text: 'Fast onboarding to dashboard' },
                  ]
              ).map((item, idx) => {
                const Icon = item.icon;
                return (
                  <div key={`${item.text}-${idx}`} className="rounded-xl border border-white/10 bg-white/[0.03] p-3">
                    <Icon className="h-4 w-4 text-orange-300" />
                    <p className="mt-2 text-xs text-slate-300">{item.text}</p>
                  </div>
                );
              })}
            </div>

            {sideNode && <div className="mt-6">{sideNode}</div>}
          </div>
        </section>

        <section className="rounded-2xl border border-white/10 bg-[#10192b]/88 p-5 md:p-6" data-testid="auth-shell-form-panel">
          {children}
        </section>
      </div>
    </div>
  );
}
